import React, { useState, useEffect } from 'react';
import Cookies from 'universal-cookie';
import {REDIRECT_URL } from "../../Config/AppConfiguration";
import UserService from '../../Services/UserService';

const Logout = ({logout}) =>  {

const [isLogout, setIsLogout] = useState(false);
const cookieNameUser = "userId";
const cookieNameToken = "accessToken";
const cookieNameCurrentUser = "currentAPIMUser";

const flushSession = async() => {
    //sessionStorage.removeItem('authRedirected');
    // sessionStorage.removeItem('codeVerifier');
    // sessionStorage.removeItem('codeChallenge');
    // sessionStorage.removeItem('oauthState');
    sessionStorage.clear(); // Clears all sessionStorage data
    console.log("Session flushed successfully.");
};

const handleLogout =  async()  =>{
  const cookies = new Cookies();
  if(cookies.get(cookieNameToken) !== null){
    cookies.remove(cookieNameToken);
    cookies.remove(cookieNameUser);
    cookies.remove(cookieNameCurrentUser);
  }
  await flushSession();
}

const signOutHandlerold = async ()=> {
  const start = performance.now();
  await UserService.logoutUser().then(async(response) => {
    console.log(response.data); // Log the response to inspect it
    const end = performance.now();
    console.log(` UserService.logoutUser API callin signout handler with axios took: ${end - start} milliseconds`);
    await handleLogout();
    setIsLogout(true);
  }).catch(error =>{
    console.log(error);
  });
}

const signOutHandler = async () => {
  try {
    await handleLogout();
    UserService.logoutUser();
  } catch (error) {
    console.log(error);
  }
};


   // Trigger logout flow when parent component sets logout={true}
   // logout prop comes from Header when user clicks "Log Out" button
   useEffect( () => {
    if(logout===true){
     signOutHandler();
    }
    },[logout]);


    return (
      <div style={{ display: 'none' }}>
      {isLogout === false ? (
        <></>
      ) : (
        setTimeout(() => {
        window.location.href = REDIRECT_URL;
        }, 2000)
      )}
      </div>
    );


      }

export default Logout;